<template>
  <div class="mask" v-if="dialogVisible">
    <div class="dialog">
      <div class="close-btn" @click="close"></div>
      <div class="title">{{ title }}</div>
      <div class="content">
        <slot name="content"></slot>
        <div class="btn-box" v-if="button" @click="confirm">
          <slot name="btn">
            <div class="confirm-btn"></div>
          </slot>
        </div>
        <slot name="tips"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    button: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    },
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .7);

  .dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 92vw;
    height: 122.266666vw;
    background: url('~@/assets/img/mobile/dialog_bg.png') no-repeat;
    background-size: 100%;
  }

  .close-btn {
    position: absolute;
    top: 6.4vw;
    right: 7.466666vw;
    width: 4vw;
    height: 4vw;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 4.5vw;
      height: .533333vw;
      background: #dfb9ab;
    }

    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
  }

  .title {
    position: absolute;
    top: 8.8vw;
    left: 50%;
    transform: translateX(-50%);
    width: 72.666666vw;
    text-align: center;
    font-size: 6.4vw;
    font-family: Noto Serif SC;
    font-weight: bold;
    color: #9f5e48;
  }

  .content {
    position: absolute;
    top: 24vw;
    left: 50%;
    transform: translateX(-50%);
    width: 72.666666vw;
  }

  .btn-box {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
  }

  .confirm-btn {
    width: 33.466666vw;
    height: 10.133333vw;
    background: url('~@/assets/img/mobile/dialog_btn.png') no-repeat;
    background-size: 100%;
  }
}
</style>